query ListMerchApps {
  apps: StreamToolsListMerchApps {
    appKey
    label
    distribution
    ownerAccountId
    ownerEmail
    installLinkUrl
    installLinkIssuedAt
    installLinkExpiresAt
    shopCount
    createdAt
  }
}
